import { Box, Flex, Heading, Icon, Spinner, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { consumeCyberspaceCallbackState } from "../../utils/cyberspaceAuth";

type Phase = "working" | "ok" | "error";

export const CyberspaceCallbackView: React.FC = () => {
  const [params] = useSearchParams();
  const [phase, setPhase] = useState<Phase>("working");

  useEffect(() => {
    document.title = "Cyberspace — powrót";
    const code = params.get("code");
    const oauthError = params.get("error");
    const ctx = consumeCyberspaceCallbackState(params.get("state"));

    if (oauthError || !code || !ctx) {
      setPhase("error");
      return;
    }

    // TODO(Krok 6 — backend): POST code + ctx.verifier do naszego backendu →
    //   wymiana na token/userinfo, a następnie:
    //   - purpose "login"  → utworzenie/zalogowanie organizatora → navigate(ctx.redirect ?? "/organizator")
    //   - purpose "verify" → oznaczenie głosującego jako zweryfikowany → navigate(ctx.redirect ?? "/")
    // Endpoint providera/backendu jeszcze nie żyje — zatrzymujemy się na potwierdzeniu powrotu.
    setPhase("ok");
  }, [params]);

  const card = (children: React.ReactNode) => (
    <Flex minH="100vh" bg="#F7F5FB" align="center" justify="center" px="20px">
      <Box w="100%" maxW="440px" bg="white" borderRadius="22px" boxShadow="0 18px 50px rgba(67,0,152,0.10)" border="1px solid rgba(67,0,152,0.06)" p={{ base: "32px 24px", md: "40px" }} textAlign="center">
        {children}
      </Box>
    </Flex>
  );

  if (phase === "working") {
    return card(
      <>
        <Spinner color="primary" size="lg" thickness="3px" mb="18px" />
        <Text color="gray.500">Łączenie z Cyberspace…</Text>
      </>
    );
  }

  if (phase === "error") {
    return card(
      <>
        <Icon as={FiAlertCircle} boxSize="44px" color="#e51f44" mb="14px" />
        <Heading fontSize="21px" color="primary" mb="8px">
          Nie udało się dokończyć
        </Heading>
        <Text fontSize="14px" color="gray.500" mb="22px">
          Połączenie z Cyberspace zostało przerwane lub wygasło. Spróbuj ponownie.
        </Text>
        <Text as={Link} to="/" fontSize="14px" color="accent" fontWeight="700">
          Wróć na stronę główną
        </Text>
      </>
    );
  }

  return card(
    <>
      <Icon as={FiCheckCircle} boxSize="44px" color="#1f9e18" mb="14px" />
      <Heading fontSize="21px" color="primary" mb="8px">
        Połączono z Cyberspace
      </Heading>
      <Text fontSize="14px" color="gray.500" mb="22px">
        Odebraliśmy potwierdzenie. Dokończenie weryfikacji po stronie serwera jest w przygotowaniu.
      </Text>
      <Text as={Link} to="/" fontSize="14px" color="accent" fontWeight="700">
        Wróć na stronę główną
      </Text>
    </>
  );
};
